export default "__VITE_ASSET__ccb2ad58__"